export enum CarouselScrollSource {
  SWIPE = 'swipe',
  BUTTON = 'button',
}

type PaginateActionEventParameters = {
  pageStart: number;
  pageEnd: number;
  scrollSource: CarouselScrollSource;
};

export type OnPaginateAction = ({
  pageStart,
  pageEnd,
  scrollSource,
}: PaginateActionEventParameters) => void;
